export default "__VITE_ASSET__C9x_Ze_A__"